<template>
	<div class="page-order page-content" v-loading="body_loading">
		<div class="main-body">
			<el-row class="hd">
				<el-col :span="24">
					<h3 style="float: none;">余额明细</h3>
					<div class="flex-block breadcrumb-box">
						<div class="position-text">位置：</div>
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item>订单管理</el-breadcrumb-item>
							<el-breadcrumb-item>余额明细</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
			</el-row>
			<div class="bd">
				<div class="search-block content-body">
					<el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline"
						@submit.native.prevent>
						<el-form-item prop="id" label="ID：">
							<el-input v-model="form_search.id" type='number' size="small" placeholder="请输入余额明细ID"
								clearable></el-input>
						</el-form-item>
					<!-- 	<el-form-item prop="user_id" label="用户ID：">
							<el-input v-model="form_search.user_id" type='number' size="small" placeholder="用户ID"
								clearable></el-input>
						</el-form-item> -->
						<el-form-item prop="user_number" label="用户编号：">
							<el-input v-model="form_search.user_number" type='number' size="small" placeholder="用户编号"
								clearable></el-input>
						</el-form-item>
						<el-form-item prop="card_number" label="实体卡号：">
							<el-input v-model="form_search.card_number" type='number' size="small" placeholder="实体卡号"
								clearable></el-input>
						</el-form-item>
						<!--<el-form-item prop="mobile" label="用户手机号：">
                            <el-input v-model="form_search.mobile" type='number' size="small" placeholder="用户手机号" clearable></el-input>
                        </el-form-item>-->
						<!-- <el-form-item prop="remark" label="明细描述：">
                            <el-input v-model="form_search.remark" size="small" placeholder="请输入明细描述" clearable></el-input>
                        </el-form-item>-->
						<el-form-item prop="transaction_id" label="充值微信支付单号：">
							<el-input v-model="form_search.transaction_id" size="small" placeholder="请输入充值微信支付单号"
								clearable></el-input>
						</el-form-item>
						<el-form-item prop="balance_pay_number" label="余额支付单号：">
							<el-input v-model="form_search.balance_pay_number" size="small" placeholder="请输入余额支付单号"
								clearable></el-input>
						</el-form-item>
						<!--<el-form-item prop="admin_id" label="管理员：">
                            <el-select size="small" v-model="form_search.admin_id" placeholder="请选择" style="width:100%;">
                                <el-option
                                        v-for="item in init_data.admin_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>-->
						<el-form-item prop="type" label="明细类型：">
							<el-select size="small" v-model="form_search.type" placeholder="请选择" style="width:100%;">
								<el-option v-for="item in init_data.type_list" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="status" label="状态：">
							<el-select size="small" v-model="form_search.status" placeholder="请选择" style="width:100%;">
								<el-option v-for="item in init_data.status_list" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="创建时间：">
							<el-date-picker size="small" clearable v-model="create_range" type="daterange"
								range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
								value-format="yyyy-MM-dd">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="完成时间：">
							<el-date-picker size="small" clearable v-model="complete_range" type="daterange"
								range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
								value-format="yyyy-MM-dd">
							</el-date-picker>
						</el-form-item>
						<el-form-item style="margin-bottom: 0;">
							<el-button type="primary" class="search-btn" size="medium" @click='searchList()'>查询
							</el-button>
						</el-form-item>
					</el-form>
				</div>
				<div class="table-block content-body">
					<div ref="contentBody">
						<el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading"
							tooltip-effect="dark" style="width: 100%;text-align: center;">
							<el-table-column prop="id" align="center" label="ID" min-width="80">
							</el-table-column>
							<!-- <el-table-column prop="user_id" align="center" label="用户ID" min-width="80">
							</el-table-column> -->
							<el-table-column prop="user_number" align="center" label="用户编号" min-width="160">
								<!--<template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.user_number"></my-textEllipsis>
                                </template>-->
								<template slot-scope="scope">
									<span class="user-num-span"
										@click="$util.goTo('/user/list',{query:{user_number:scope.row.user_number}})">{{scope.row.user_number}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="card_number" align="center" label="实体卡号" min-width="120">
							</el-table-column>
							<el-table-column prop="nick_name" align="center" label="用户昵称" min-width="120">
							</el-table-column>
							<el-table-column prop="avatar_url" align="center" label="用户头像" min-width="80">
								<template slot-scope="scope">
									<img class="cursor" :src="scope.row.avatar_url" height="23"
										@click="dlg_preview.img_url = scope.row.avatar_url;dlg_preview.visible = true;"
										title="点击查看" />
								</template>
							</el-table-column>
							<!--<el-table-column prop="mobile" align="center" label="用户手机" min-width="140">
                            </el-table-column>-->
							<el-table-column prop="type_name" align="center" label="余额明细类型" min-width="120">
								<template slot-scope="scope">
									<span :class="'tag-span tag-'+scope.row.type">{{scope.row.type_name}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="balance" align="center" label="交易金额（元）" min-width="120">
							</el-table-column>
							<el-table-column prop="surplus_balance" align="center" label="剩余余额（元）" min-width="120">
							</el-table-column>
							<el-table-column prop="remark" align="center" label="明细描述" min-width="200">
								<template slot-scope="scope">
									<my-textEllipsis v-if="is_refresh" :content="scope.row.remark"></my-textEllipsis>
								</template>
							</el-table-column>
							<el-table-column prop="admin_name" align="center" label="操作者" min-width="120">
							</el-table-column>
							<el-table-column prop="status_name" align="center" label="状态" min-width="100">
								<template slot-scope="scope">
									<span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="c_time" align="center" label="创建时间" min-width="160">
							</el-table-column>
							<el-table-column prop="success_date" align="center" label="完成时间" min-width="160">
							</el-table-column>
							<el-table-column prop="balance_pay_number" align="center" label="余额支付单号" min-width="230">
							</el-table-column>
							<el-table-column prop="transaction_id" align="center" label="充值微信支付单号" min-width="230">
							</el-table-column>
						</el-table>
					</div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="table_data.page_info.page" :page-sizes="[10,30, 50,80,100]"
						:page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next"
						:total="table_data.page_info.total">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
			<img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
		</el-dialog>
	</div>
</template>
<script>
	export default {
		name: 'balance',
		data() {
			return {
				clientHeight: '',
				body_loading: false,
				is_refresh: true,
				create_range: '',
				complete_range: '',
				form_search: {
					id: '',
					user_id: '',
					user_number: '',
					card_number: '',
					//admin_id:-1,
					//mobile:'',
					//remark:'',
					transaction_id: '',
					balance_pay_number: '',
					start_create_date: '',
					end_create_date: '',
					start_complete_date: '',
					end_complete_date: '',
					type: -1,
					status: -1
				},
				init_data: {
					type_list: [],
					status_list: [],
					admin_list: []
				},
				table_data: {
					loading: false,
					list: [],
					page_info: {
						page: 1,
						pageSize: 10,
						total: 130
					}
				},
				dlg_preview: {
					visible: false,
					img_url: ''
				}
			}
		},
		created() {
			document.title = '余额明细';
			this.getList();
		},
		methods: {
			searchList() {
				var _this = this;
				_this.table_data.page_info.page = 1;
				_this.getList();
			},
			getList() {
				var _this = this;
				var params = _this.form_search;
				params.p = _this.table_data.page_info.page;
				params.pageSize = _this.table_data.page_info.pageSize;
				_this.table_data.loading = true;
				var status_list = [{
					id: -1,
					name: '全部'
				}];
				this.$client.get('/adminapi/userbalancepay/list', params, function(res, message) {
					_this.table_data.list = res.list;
					_this.table_data.page_info = res.pager;
					_this.init_data.type_list = status_list.concat(res.type_name_list);
					_this.init_data.status_list = status_list.concat(res.status_name_list);
					_this.init_data.admin_list = status_list.concat(res.admin_name_list);
					_this.table_data.loading = false;
				}, function(res) {
					_this.table_data.loading = false;
				});
			},
			handleSizeChange(val) {
				//console.log(`每页 ${val} 条`);
				this.table_data.page_info.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				//console.log(`当前页: ${val}`);
				this.table_data.page_info.page = val;
				this.getList();
			},
			changeFixed(clientHeight) {
				this.$refs.contentBody.style.minHeight = (clientHeight - 394) + 'px';
			}
		},
		mounted() {
			// 获取浏览器可视区域高度
			this.clientHeight = `${document.documentElement.clientHeight}` //document.body.clientWidth;
			//console.log(self.clientHeight);
			window.onresize = function temp() {
				this.clientHeight = `${document.documentElement.clientHeight}`;
			};
		},
		watch: {
			// 如果 `clientHeight` 发生改变，这个函数就会运行
			clientHeight: function() {
				this.changeFixed(this.clientHeight)
			},
			create_range(newVal) {
				//console.log(newVal);
				if (newVal == null) {
					this.form_search.start_create_date = '';
					this.form_search.end_create_date = '';
				} else {
					this.form_search.start_create_date = newVal[0];
					this.form_search.end_create_date = newVal[1];
				}
			},
			complete_range(newVal) {
				//console.log(newVal);
				if (newVal == null) {
					this.form_search.start_complete_date = '';
					this.form_search.end_complete_date = '';
				} else {
					this.form_search.start_complete_date = newVal[0];
					this.form_search.end_complete_date = newVal[1];
				}
			}
		}
	}
</script>
<style>

</style>
<style scoped>
	.status-0 {
		color: #9a9a9a;
	}

	.status-1 {
		color: #F31A5C;
	}

	.status-2 {
		color: #F27918;
	}

	.status-3 {
		color: #0C67F0;
	}

	.status-9 {
		color: #04B365;
	}

	.status-10 {
		color: #666;
	}
</style>
